"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RWSToolsProductCardDataComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const types_1 = require("../../types");
//@ts-ignore                
let rwsTemplate = T.html `<div class="rws-tools-product-card-data">
    ${(0, fast_element_1.when)(x => x.hasProducts, (0, fast_element_1.html) `
        <div class="products-container">
            <div class="products-summary">
                <span class="products-count">
                    ${x => x.productsCount} ${x => x.productsCount === 1 ? 'productCard.product'.t() : 'productCard.products'.t()}
                </span>
            </div>
            
            <div class="products-grid ${x => x.isSingleProduct ? 'single-product' : 'product-list'}">
                ${(0, fast_element_1.repeat)(x => x.productCardData.data, (0, fast_element_1.html) `
                    <div class="product-item" @click="${(item, c) => c.parent.openProductLink(item.url)}">
                        <div class="product-image-container">
                            <img 
                                class="product-image" 
                                :src="${(item, c) => c.parent.getImageSrc(item.imageUrl)}"
                                :alt="${item => item.name}"
                                @error="${(item, c) => c.parent.onImageError(c.event)}"
                                loading="lazy"
                            />
                        </div>
                        
                        <div class="product-details">
                            <div class="product-header-info">
                                <h4 class="product-name">${item => item.name}</h4>
                                <div class="product-id">ID: ${item => item.id}</div>
                            </div>
                            
                            ${(0, fast_element_1.when)(item => item.description, (0, fast_element_1.html) `
                                <div class="product-description">
                                    ${(item, c) => item.description}
                                </div>
                            `)}
                            
                            <div class="product-pricing">
                                <div class="price-row">
                                    <span class="price-label">${'productCard.grossPrice'.t()}:</span>
                                    <span class="price-value gross">${(item, c) => c.parent.formatPrice(item.prices.gross)}€</span>
                                </div>
                                <div class="price-row">
                                    <span class="price-label">${'productCard.netPrice'.t()}:</span>
                                    <span class="price-value net">${(item, c) => c.parent.formatPrice(item.prices.net)}€</span>
                                </div>
                                <div class="price-row">
                                    <span class="price-label">${'productCard.vat'.t()}:</span>
                                    <span class="price-value vat">${item => item.prices.vat}%</span>
                                </div>
                            </div>
                            
                            ${(0, fast_element_1.when)(item => item.categoryId, (0, fast_element_1.html) `
                                <div class="product-meta">
                                    <span class="category-info">
                                        <i class="simple-icon-tag"></i>
                                        ${'productCard.category'.t()}: ${item => item.categoryId}
                                    </span>
                                </div>
                            `)}
                            
                            <div class="product-actions">
                                <a href="${item => item.url}" class="view-product-btn" target="_blank">
                                    <i class="simple-icon-eye"></i>
                                    ${'productCard.viewProduct'.t()}
                                </a>
                            </div>
                        </div>
                    </div>
                `)}
            </div>
        </div>
    `)}

    ${(0, fast_element_1.when)(x => !x.hasProducts, (0, fast_element_1.html) `
        <div class="empty-state">
            <span class="empty-icon">📦</span>
            <p>${'productCard.noProducts'.t()}</p>
            <small class="empty-suggestion">${'productCard.trySearching'.t()}</small>
        </div>
    `)}
</div>`;
require("./styles/layout.scss");
const styles = T.css `@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rws-tools-product-card-data {
  border-radius: 12px;
}
.rws-tools-product-card-data .product-header {
  margin-bottom: 20px;
}
.rws-tools-product-card-data .product-header h3 {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 12px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.rws-tools-product-card-data .product-header .product-type-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--primary-color, #007bff);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
}
.rws-tools-product-card-data .product-header .product-type-badge.single {
  background: var(--success-color, #28a745);
}
.rws-tools-product-card-data .product-header .product-type-badge .badge-icon {
  font-size: 1rem;
}
.rws-tools-product-card-data .products-container {
  background: var(--bg-secondary, #f8f9fa);
  border-radius: 8px;
  padding: 16px;
}
.rws-tools-product-card-data .products-container .products-summary {
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-color, #e9ecef);
}
.rws-tools-product-card-data .products-container .products-summary .products-count {
  font-weight: 600;
  color: var(--text-primary, #333);
  font-size: 0.95rem;
}
.rws-tools-product-card-data .products-container .products-grid {
  display: grid;
  gap: 16px;
}
.rws-tools-product-card-data .products-container .products-grid.single-product {
  grid-template-columns: 1fr;
  max-width: 600px;
  margin: 0 auto;
}
.rws-tools-product-card-data .products-container .products-grid.product-list {
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
}
@media (max-width: 768px) {
  .rws-tools-product-card-data .products-container .products-grid.product-list {
    grid-template-columns: 1fr;
  }
}
.rws-tools-product-card-data .products-container .products-grid .product-item {
  background: white;
  border: 1px solid var(--border-color, #e9ecef);
  border-radius: 12px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rws-tools-product-card-data .products-container .products-grid .product-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-color: var(--primary-color, #007bff);
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-image-container {
  width: 100%;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  background: var(--bg-light, #f8f9fa);
  display: flex;
  align-items: center;
  justify-content: center;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-image-container .product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}
.rws-tools-product-card-data .products-container .products-grid .product-item:hover .product-image {
  transform: scale(1.05);
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-header-info .product-name {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: var(--text-primary, #333);
  line-height: 1.3;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-header-info .product-id {
  font-size: 0.875rem;
  color: var(--text-muted, #6c757d);
  font-weight: 500;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-description {
  font-size: 0.9rem;
  color: var(--text-secondary, #555);
  line-height: 1.4;
  margin: 0;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing {
  background: var(--bg-light, #f8f9fa);
  border-radius: 8px;
  padding: 12px;
  border-left: 3px solid var(--primary-color, #007bff);
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing .price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing .price-row:last-child {
  margin-bottom: 0;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing .price-row .price-label {
  font-size: 0.875rem;
  color: var(--text-muted, #6c757d);
  font-weight: 500;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing .price-row .price-value {
  font-weight: 700;
  font-size: 0.95rem;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing .price-row .price-value.gross {
  color: var(--success-color, #28a745);
  font-size: 1.1rem;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing .price-row .price-value.net {
  color: var(--info-color, #17a2b8);
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-pricing .price-row .price-value.vat {
  color: var(--warning-color, #ffc107);
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-meta .category-info {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  color: var(--text-muted, #6c757d);
  background: var(--bg-light, #f8f9fa);
  padding: 4px 8px;
  border-radius: 16px;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-meta .category-info i {
  font-size: 0.8rem;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-actions {
  margin-top: auto;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-actions .view-product-btn {
  width: 100%;
  background: var(--primary-color, #007bff);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-actions .view-product-btn:hover {
  background: var(--primary-dark, #0056b3);
  transform: translateY(-1px);
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-actions .view-product-btn:active {
  transform: translateY(0);
}
.rws-tools-product-card-data .products-container .products-grid .product-item .product-details .product-actions .view-product-btn i {
  font-size: 0.9rem;
}
.rws-tools-product-card-data .empty-state {
  text-align: center;
  padding: 40px 20px;
  color: var(--text-muted, #6c757d);
}
.rws-tools-product-card-data .empty-state .empty-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 16px;
  opacity: 0.7;
}
.rws-tools-product-card-data .empty-state p {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  color: var(--text-secondary, #555);
}
.rws-tools-product-card-data .empty-state .empty-suggestion {
  font-size: 0.875rem;
  opacity: 0.8;
}`;
const shadowOptions = { "mode": "open" };
let RWSToolsProductCardDataComponent = class RWSToolsProductCardDataComponent extends client_1.RWSViewComponent {
    get hasProducts() {
        var _a;
        return ((_a = this.productCardData) === null || _a === void 0 ? void 0 : _a.data) && this.productCardData.data.length > 0;
    }
    get productsCount() {
        var _a, _b;
        return ((_b = (_a = this.productCardData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) || 0;
    }
    get isSingleProduct() {
        var _a;
        return ((_a = this.productCardData) === null || _a === void 0 ? void 0 : _a.type) === 'single';
    }
    get isProductList() {
        var _a;
        return ((_a = this.productCardData) === null || _a === void 0 ? void 0 : _a.type) === 'list';
    }
    formatPrice(price) {
        return price.toFixed(2);
    }
    getImageSrc(imageUrl) {
        return imageUrl || '/assets/images/product-placeholder.png';
    }
    onImageError(event) {
        const img = event.target;
        img.src = '/assets/images/product-placeholder.png';
    }
};
exports.RWSToolsProductCardDataComponent = RWSToolsProductCardDataComponent;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof types_1.ProductCardData !== "undefined" && types_1.ProductCardData) === "function" ? _a : Object)
], RWSToolsProductCardDataComponent.prototype, "productCardData", void 0);
exports.RWSToolsProductCardDataComponent = RWSToolsProductCardDataComponent = __decorate([
    (0, client_1.RWSView)('rws-tools-product-card-data', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], RWSToolsProductCardDataComponent);
RWSToolsProductCardDataComponent.defineComponent();
